import React from 'react';
import { useLocation, useNavigate } from 'react-router';
import { OutlineArrowRight } from '@producer/ui-kit';

import { SettingsMenu } from '../../../features/settings/components/settings-menu';

import shared from './user-settings-page.module.scss';
import styles from './user-settings-page.layout.module.scss';

type MenuOptions = {
  key: string;
  label: string;
  href: string;
  external?: boolean;
};

type SettingsLayoutProps = React.PropsWithChildren<{
  title: string;
  menu: MenuOptions[];
}>;

export const UserSettingsPageLayout: React.FC<SettingsLayoutProps> = ({
  children,
  title,
  menu,
}) => {
  const navigate = useNavigate();
  const location = useLocation() as { state: { prevPath: string } };

  const goBack = () => {
    if (location.state && location.state.prevPath) {
      navigate(location.state.prevPath);
    } else {
      navigate(`/`);
    }
  };

  return (
    <div className={styles['wrapper']}>
      <div className={`desktop-only ${shared['navigation-bar']}`}>
        <div className={styles['header']}>
          <a className={styles['back-button']} onClick={goBack}>
            <OutlineArrowRight />

            <span>Back</span>
          </a>

          <h1 className={styles['settings-title']}>{title}</h1>
        </div>

        <div className={styles['menu-container']}>
          <SettingsMenu items={menu} />
        </div>
      </div>

      <div className={styles['content']}>
        <div className={styles['content-container']}>
          <div className={styles['screens']}>{children}</div>
        </div>
      </div>
    </div>
  );
};
